module.exports = __webpack_public_path__ + "static/media/jasmine-judge.21d2aa7d.jpeg";